import React, { Component } from 'react';
import HomeImage from "components/HomeImage";

import './index.css';

// import ResumePDF from "./eben_bitonte_resume.pdf";

const SOCIAL_LINKS = {
    resumse: {
        href: 'https://s3.amazonaws.com/www.ebenbitonte.com/eben_bitonte_resume.pdf',
        text: 'Resume'
    },
    linkedin: {
        href: 'https://www.linkedin.com/in/ebenbitonte/',
        text: 'LinkedIn'
    },
    twitter: {
        href: 'https://www.twitter.com/ebenbitonte',
        text: 'Twitter'
    },
    spotify: {
        href: 'https://open.spotify.com/user/ebitonte',
        text: 'Spotify'
    }
}

export default class Home extends Component {
    render() {
        return (
            <main className='container'>
                <h1 className='name'>Eben James Bitonte</h1>
                <section className='home-section'>
                    <h2 className='home-section__header'>About Me</h2>
                    <p className='home-section__about1'>{`I'm an optimist and an enthusiast`}</p>
                    <p className='home-section__about21'>{`You can find me watching Manchester City at 7:30AM with a pourover in hand,`}</p>
                    <p className='home-section__about22'>{`reading the latest issue of Monocle,`}</p>
                    <p className='home-section__about23'>{`or running through Central Park listening to Tame Impala`}</p>
                </section>
                <section className='home-section'>
                    <h2 className='home-section__header'>Currently</h2>
                    <p>Creating products at <a href='https://www.fullsleep.com'>Full Sleep</a> for those who struggle with insomnia.</p>
                    <HomeImage 
                        src='fullsleep.png' 
                        href='https://www.fullsleep.com'
                        alt='The Full Sleep wireless tracking device on a nightstand' 
                    />
                </section>
                <section className='home-section'>
                    <h2 className='home-section__header'>Previously</h2>
                    <p>Creating products at Koko Labs to enable older adults to stay independent as long as possible.</p>
                    <p className='extra-space'>Building the most trusted global business news on the web at <a href='https://www.bloomberg.com'>bloomberg.com</a>.</p>
                    <p className='extra-space'>Studying Mathematics and Computer Science at MIT.</p>
                </section>
                <section className='home-section'>
                    <h2 className='home-section__header'>Connect</h2>
                    {Object.keys(SOCIAL_LINKS).map(link => (
                        <p><a href={SOCIAL_LINKS[link].href}>{SOCIAL_LINKS[link].text}</a></p>
                    ))}
                </section>
            </main>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Home/index.js